module.exports = __webpack_public_path__ + "img/back_home.434bfe08.png";